import React from 'react';
import styled from 'styled-components';
import {
  BorderRadius,
  Colors,
  FontFamily,
  FontSize,
  FontWeight,
  LineHeight,
  Spacing,
} from 'web-common/src/shared/styles';

export const CapacityMessage = styled.div<{ type: 'error' | 'warning' }>`
  border-radius: ${BorderRadius.S};
  background: ${({ type }) => (type === 'error' ? Colors.BELL_PEPPER_LITE_20 : Colors.JACKFRUIT_LITE_10)};
  color: ${({ type }) => (type === 'error' ? Colors.BELL_PEPPER_DARK_30 : Colors.JACKFRUIT_DARK_30)};
  padding: ${Spacing.THREE_QUARTERS};
  margin-top: ${Spacing.QUARTER};
  margin-bottom: ${Spacing.QUARTER};
  font-size: ${FontSize.XS};
  line-height: ${LineHeight.XXS};
  font-weight: ${FontWeight.NORMAL};
  font-family: ${FontFamily.SANS};

  h3 {
    margin: ${Spacing.EIGHTH} 0 ${Spacing.HALF};
    font-size: ${FontSize.XS};
    font-weight: ${FontWeight.BOLD};
  }
`;

interface ConsumerOrderCartCapacityWarningProps {
  isOrderingAllRemainingItems: boolean;
  isOrderingMoreThanDeliveryDateCapacity: boolean;
  numDishesRemaining: number;
}

export const ConsumerOrderCartCapacityWarning: React.FC<ConsumerOrderCartCapacityWarningProps> = ({
  isOrderingAllRemainingItems,
  isOrderingMoreThanDeliveryDateCapacity,
  numDishesRemaining,
  ...props
}) => {
  if (!isOrderingAllRemainingItems && !isOrderingMoreThanDeliveryDateCapacity) return null;

  const absAmountRemaining = Math.abs(numDishesRemaining);
  return (
    <CapacityMessage type={isOrderingMoreThanDeliveryDateCapacity ? 'error' : 'warning'} {...props}>
      <h3>Capacity Warning</h3>
      {isOrderingMoreThanDeliveryDateCapacity ? (
        <>
          Your cart has{' '}
          <strong>
            {absAmountRemaining} more {absAmountRemaining > 1 ? 'dishes' : 'dish'}
          </strong>{' '}
          than this shef can cook on this delivery date. Remove {absAmountRemaining > 1 ? 'some dishes' : 'one dish'} or
          change to another delivery date.
        </>
      ) : (
        'You have the max number of dishes this shef can cook on this delivery date. You may continue with your order for this date or change delivery dates to add more.'
      )}
    </CapacityMessage>
  );
};
